import React from "react";
import { Grid, TextField, InputAdornment } from "@mui/material";
import { Field } from "formik";
import InputMask from "react-input-mask";
import { AccountCircle, CalendarToday } from "@mui/icons-material";

const PersonalInfoForm = ({ values, errors, touched, handleChange }) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Field
        as={TextField}
        name="fullName"
        label="Nome"
        fullWidth
        margin="normal"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          ),
        }}
        error={touched.fullName && Boolean(errors.fullName)}
        helperText={touched.fullName && errors.fullName}
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <InputMask mask="999.999.999-99" value={values.cpf} onChange={handleChange}>
        {() => (
          <TextField
            fullWidth
            name="cpf"
            label="CPF"
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            error={touched.cpf && Boolean(errors.cpf)}
            helperText={touched.cpf && errors.cpf}
          />
        )}
      </InputMask>
    </Grid>
    <Grid item xs={12} md={4}>
      <InputMask mask="(99) 99999-9999" value={values.phoneNumber} onChange={handleChange}>
        {() => (
          <TextField
            fullWidth
            name="phoneNumber"
            label="Telefone"
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            error={touched.phoneNumber && Boolean(errors.phoneNumber)}
            helperText={touched.phoneNumber && errors.phoneNumber}
          />
        )}
      </InputMask>
    </Grid>
    <Grid item xs={12} md={4}>
      <InputMask mask="99/99/9999" value={values.birthDate} onChange={handleChange}>
        {() => (
          <TextField
            fullWidth
            name="birthDate"
            label="Data de Nascimento"
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarToday />
                </InputAdornment>
              ),
            }}
            error={touched.birthDate && Boolean(errors.birthDate)}
            helperText={touched.birthDate && errors.birthDate}
          />
        )}
      </InputMask>
    </Grid>
  </Grid>
);

export default PersonalInfoForm;